import useAxios from 'axios-hooks';
import { Drupal } from '@typings/drupal';

export const useAlerts = (language: string) => {
  return useAxios<Drupal.ScheduledAlert[]>({
    url: `${process.env.GATSBY_BACKEND_APP_BASE_URL}/${language}/restapi/alerts`,
    withCredentials: true,
  });
};
